<div class="wrapper">
  <div class="header-title">{{ title }}</div>
  <div class="tsp-wrapper" data-cy="tsp-wrapper-div">
  <ng-content></ng-content>
  </div>
</div>
